import axios from "axios";
import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader, { LoaderType } from "../component/common-component/Loader";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import { commonservices } from "../services/CommonServices";
import MagicWand from "../assets/images/MagicWand.svg";
import editpencilIcon from "../assets/images/editpencilIcon.svg";
import robot from "../assets/images/robot.gif";
import EditAIImageModal from "./EditAIImageModal";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";
let test1 = [
  "https://image.lexica.art/full_jpg/0ae3ac26-a825-4122-8b9d-1ac8fdd4e1ce",
  "https://image.lexica.art/full_jpg/0e9a4302-afc1-4897-9401-47c6f96cd85f",
  "https://image.lexica.art/full_jpg/0ec69770-b6e9-4c6d-b3f7-34a50b041e45",
  "https://image.lexica.art/full_jpg/116a4d4e-9161-4c9b-9bc6-c4faa845cb97",
  "https://image.lexica.art/full_jpg/125612c6-d3c4-4e10-9906-95603594624f",
  "https://image.lexica.art/full_jpg/1871890a-5ea2-4f5a-9373-bcac8ff98bcc",
  "https://image.lexica.art/full_jpg/1b20162a-0b47-4a7d-bd7a-a3c13c3ae336",
  "https://image.lexica.art/full_jpg/1ca6c53c-4d35-491d-b5c8-c3d4e816d008",
  "https://image.lexica.art/full_jpg/1d0178d0-6dc4-491d-86f9-505ab0d14936",
  "https://image.lexica.art/full_jpg/208f4dbb-90c4-4e14-b88d-ce70bcf3b198",
  "https://image.lexica.art/full_jpg/23d77f88-b788-4388-86ce-4313ca2e4ec9",
  "https://image.lexica.art/full_jpg/257419d4-ef19-4be7-8b12-f7be75c9e9cf",
  "https://image.lexica.art/full_jpg/2955879a-d5da-4da9-b99e-d3d958cc9ca4",
  "https://image.lexica.art/full_jpg/2bd099d9-e32a-4801-b5b9-86610e6233cc",
  "https://image.lexica.art/full_jpg/30b02bde-4c09-4a8d-83d9-e993b3da33c3",
  "https://image.lexica.art/full_jpg/33525349-5071-457c-aedb-1e96fa347868",
  "https://image.lexica.art/full_jpg/35071254-8333-443b-b3a7-b8d9b369fc7a",
  "https://image.lexica.art/full_jpg/3a336177-3c3d-4bb4-b3d9-1e5e2c44f731",
  "https://image.lexica.art/full_jpg/436f5287-6fed-4037-a67c-96f79decedfc",
  "https://image.lexica.art/full_jpg/459e9531-feb2-4ced-90c5-5b92e71beec0",
  "https://image.lexica.art/full_jpg/49109cdb-7415-48a2-9d0e-af641c15cd8a",
  "https://image.lexica.art/full_jpg/4caedfee-6dbe-4272-9d5f-a3ebc87af5de",
  "https://image.lexica.art/full_jpg/4cb3826d-390b-4f9e-b2ea-2222ae9d18aa",
  "https://image.lexica.art/full_jpg/4fb7dca4-1b89-4125-8c1e-beb3ef8b0e56",
  "https://image.lexica.art/full_jpg/5044cf44-8ca1-4b38-aeba-7f4f6b1fb705",
  "https://image.lexica.art/full_jpg/5614aeb4-7ea5-44e0-88ea-87034ca8c372",
  "https://image.lexica.art/full_jpg/57e3714e-1e60-4d33-82a6-52928dfb9ddf",
  "https://image.lexica.art/full_jpg/583181f4-d295-4183-b92e-2e8f60c83f82",
  "https://image.lexica.art/full_jpg/5bd13f33-461e-439c-b718-18db9c5d16ed",
  "https://image.lexica.art/full_jpg/5cbdc8ee-e127-451a-81fa-3baa8d119fa2",
  "https://image.lexica.art/full_jpg/5d8d25fc-b962-449b-b2bb-437c1381e55b",
  "https://image.lexica.art/full_jpg/60d87371-01d0-4b61-a997-668883431216",
  "https://image.lexica.art/full_jpg/66bac8fc-166e-4e6b-8d5f-9e6f7ef69a54",
  "https://image.lexica.art/full_jpg/6adf3fd6-8cc6-4113-8cb8-7cafd6fd998a",
  "https://image.lexica.art/full_jpg/6efb2395-5684-40e3-8828-22da88efeb64",
  "https://image.lexica.art/full_jpg/74353056-de07-4cae-aebe-ad9a9ce622ad",
  "https://image.lexica.art/full_jpg/7a42ed5d-5716-47be-8f56-b9e14aaa68c4",
  "https://image.lexica.art/full_jpg/7bf78eba-42d0-4125-86fb-8a10861e8627",
  "https://image.lexica.art/full_jpg/7fdc8c58-db86-4181-89c7-fe468d4eb110",
  "https://image.lexica.art/full_jpg/82c7fb9c-5eef-4703-8027-6ef24942936a",
  "https://image.lexica.art/full_jpg/82dee480-6409-4b10-942c-323ab20d9a96",
  "https://image.lexica.art/full_jpg/84391d9d-e56a-4720-b274-3c8314f40bfe",
  "https://image.lexica.art/full_jpg/8564cc66-a532-49b0-adc1-968d3f9169d3",
  "https://image.lexica.art/full_jpg/8e095223-0e28-4c37-af24-a8799af0fdbe",
  "https://image.lexica.art/full_jpg/8e509d21-fc0f-4760-b3df-d4d5a2835e44",
  "https://image.lexica.art/full_jpg/91018fd0-3092-458e-94ad-87d59015c1e1",
  "https://image.lexica.art/full_jpg/9203e973-9854-4c00-adcf-ed145b8dbbdb",
  "https://image.lexica.art/full_jpg/95ce9de4-d41e-4fa8-9b42-bf849ccd940e",
  "https://image.lexica.art/full_jpg/96679a9a-1c4f-4672-ae5f-78fcc9311a5d",
  "https://image.lexica.art/full_jpg/98131ce7-2bf3-4146-8720-76874cd94341",
  "https://image.lexica.art/full_jpg/996c8674-ceaa-4689-8a52-ad0ae88cca5a",
  "https://image.lexica.art/full_jpg/a33fa59f-98a0-4b54-b446-f25d85c1b4a6",
  "https://image.lexica.art/full_jpg/a5e00f40-c9e6-4ab2-a31d-3f7f68f37bee",
  "https://image.lexica.art/full_jpg/a800b869-60dc-47b3-af97-1a6a2876089e",
  "https://image.lexica.art/full_jpg/a9dd4eed-eca3-4d22-8eb7-89fb66077cd3",
  "https://image.lexica.art/full_jpg/aa84ca11-ce9c-4857-befd-4dc3394dd51a",
  "https://image.lexica.art/full_jpg/ace35e15-0910-46a4-a3a1-7f491f212a21",
  "https://image.lexica.art/full_jpg/aed105c9-fe96-4ff5-8e49-35d368d009bd",
  "https://image.lexica.art/full_jpg/aef6b15c-f87c-4226-a2bd-1be7ca464b8b",
  "https://image.lexica.art/full_jpg/af6679fd-65fa-4d0f-a4df-b6d08e5312d7",
  "https://image.lexica.art/full_jpg/b4323f96-8ced-4e29-972a-e416c6573e8e",
  "https://image.lexica.art/full_jpg/b43363b2-f5dd-4f31-9462-33b5271f60c1",
  "https://image.lexica.art/full_jpg/b93a73a1-d5b1-4f91-9555-f406292e0442",
  "https://image.lexica.art/full_jpg/bad6f6fa-282f-4349-b443-3e6c6c8db9ec",
  "https://image.lexica.art/full_jpg/c6c2945a-cba9-48d5-917f-28b31cb2d54b",
  "https://image.lexica.art/full_jpg/ca0d4642-3c84-4362-bf13-128c67bd2dee",
  "https://image.lexica.art/full_jpg/ca60772b-3999-42ed-a4ef-add8a6e0e37c",
  "https://image.lexica.art/full_jpg/cc47eeba-20ea-4ab5-8534-62adc89efcd0",
  "https://image.lexica.art/full_jpg/cddbee2b-677f-46ea-b47a-ff6fb67cef4c",
  "https://image.lexica.art/full_jpg/d21ef19a-9794-4cae-ba77-d7c5510845fa",
  "https://image.lexica.art/full_jpg/ed55c55e-3f1a-472c-9d46-535fe90c4408",
  "https://image.lexica.art/full_jpg/effa4793-f260-4e86-b4da-a4c1111c4882",
  "https://image.lexica.art/full_jpg/f1fce9b0-e173-448b-94fc-80665d749d62",
  "https://image.lexica.art/full_jpg/fbc2de76-239b-4b3d-abba-773c256302fe",
  "https://image.lexica.art/full_jpg/fc84e396-6573-413b-bd63-cb5c308d1816",
  "https://image.lexica.art/full_jpg/fd02c74f-747d-4761-9eb9-0a6e190a3d12",
  "https://image.lexica.art/full_jpg/fe04a09b-4d7f-40e5-b45e-c3afd93cca58",
];
const AIImageGenerateModal = (props) => {
  const OpenAIkey = process.env.REACT_APP_OPENAI_KEY;
  const RAPIDkey = process.env.REACT_APP_RAPID_KEY;
  const [prompt, setPrompt] = useState("");
  const [ImageName, setImageName] = useState("");
  const [ImageIndex, setImageIndex] = useState("");
  const [optimizedPrompts, setOptimizedPrompts] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [loadingPrompt, setLoadingPrompt] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const [error, setError] = useState("");
  const [SelectedImage, setSelectedImage] = useState("");
  const [SelectedModalShow, setSelectedModalShow] = useState(false);
  const [MachineBannersList, setMachineBannersList] = useState(
    props?.input?.machinebanner?.length > 0 ? props?.input?.machinebanner : []
  );
  const [MachineBannersURLList, setMachineBannersURLList] = useState([]);
  // Handle optimizing the prompt
  const handleOptimizePrompt = async () => {
    if (!prompt.trim()) return;
    setLoadingPrompt(true);
    setError("");
    try {
      const response = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${OpenAIkey}`, // Replace with your OpenAI API key
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            model: "gpt-4o-mini",
            messages: [
              {
                role: "system",
                content: "You are an AI that generates image descriptions.",
              },
              {
                role: "user",
                content: `Enhance this description: ${prompt}`,
              },
            ],
            // max_tokens: 100,
            // temperature: 0.7,
          }),
        }
      );
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }
      const data = await response.json();
      const optimizedPrompt = data.choices[0]?.message?.content?.trim();
      if (optimizedPrompt) {
        setOptimizedPrompts((prev) => [...prev, optimizedPrompt]);
      } else {
        setError("No optimized prompt received from the API.");
        toast.error("No optimized prompt received from the API.");
      }
    } catch (error) {
      setError("Failed to optimize prompt. Please try again.");
      toast.error("Failed to optimize prompt. Please try again.");
    } finally {
      setLoadingPrompt(false);
    }
  };

  const cropImage = (imageUrl, cropWidth, cropHeight) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // Enable cross-origin for remote images
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        // Set canvas dimensions to the crop size
        canvas.width = cropWidth;
        canvas.height = cropHeight;
        // Calculate cropping start positions from the center
        const startX = Math.max((img.width - cropWidth) / 2, 0); // Ensure it's not negative
        const startY = Math.max((img.height - cropHeight) / 2, 0);
        // Draw the cropped image on the canvas
        ctx.drawImage(
          img,
          startX, // Source X
          startY, // Source Y
          cropWidth, // Source width
          cropHeight, // Source height
          0, // Destination X
          0, // Destination Y
          cropWidth, // Destination width
          cropHeight // Destination height
        );
        // Convert the canvas content to a data URL
        const croppedImage = canvas.toDataURL("image/jpeg");
        resolve(croppedImage);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = imageUrl; // Set the image source to the provided URL
    });
  };

  // Handle generating images
  const generateImage = async () => {
    setOptimizedPrompts([]);
    if (!prompt.trim()) return;
    setLoadingImage(true);
    setError("");
    const customPrompt = `${prompt} oriented image with height between 400px to 450px and width between 1400px to 1450px.`;
    const options = {
      method: "POST",
      url: "https://ai-image-generator3.p.rapidapi.com/generate",
      headers: {
        "x-rapidapi-key": RAPIDkey,
        "x-rapidapi-host": "ai-image-generator3.p.rapidapi.com",
        "Content-Type": "application/json",
      },
      data: {
        prompt: customPrompt,
        page: 1,
      },
    };
    try {
      const response = await axios.request(options);
      if (response?.data?.message) {
        toast.error(response?.data?.message);
      }
      const images = (response?.data?.results?.images || []).slice(0, 8);
      const croppedImages = await Promise.all(
        images.map(async (url) => {
          return await cropImage(url, 1450, 450);
        })
      );

      setImageUrls(croppedImages);
    } catch (error) {
      toast.error("Failed to generate images. Please try again.");
      setError("Failed to generate images. Please try again.");
    } finally {
      setLoadingImage(false);
    }
  };
  const handlePromptClick = (selectedPrompt) => {
    setPrompt(selectedPrompt);
  };
  async function fnMachineBanner(url1, ait) {
    if (MachineBannersList?.length > 7) {
      toast.error("Cannot add more than 7 images.");
      return;
    }
    try {
      let orgurl = ait;
      url1 = await commonservices.downloadFileFromURL(
        url1,
        {
          returnType: "blob",
        },
        ait
      );
      if (!url1) {
        toast.error("Failed to download the file.");
        return;
      }
      const img = new Image();
      img.src = URL.createObjectURL(url1);
      let temp = [];
      let URL2 = [];
      if (MachineBannersURLList?.length > 0 || MachineBannersList?.length > 0) {
        if (MachineBannersURLList.includes(orgurl)) {
          URL2 = MachineBannersURLList.filter((f) => f !== orgurl);
          temp = MachineBannersList?.filter((x, i) => x?.name !== url1?.name);
          temp?.length > 0
            ? props?.setbannerimagestate(temp?.[temp?.length - 1])
            : props?.setbannerimagestate("");
        } else {
          URL2 = [...MachineBannersURLList, orgurl];
          temp = [...MachineBannersList, url1];
          props?.setbannerimagestate(url1);
        }
      } else {
        URL2 = [orgurl];
        temp = [url1];
        props?.setbannerimagestate(url1);
      }
      const combinedFiles = temp;
      if (combinedFiles.length > 7 || props?.input?.machinebanner?.length > 8) {
        toast.error("Cannot add more than 7 images.");
        props?.setbannerimagestate(
          props?.input?.machinebanner?.[props?.input?.machinebanner?.length - 1]
        );
        return;
      }
      const totalSize =
        combinedFiles.reduce((sum, file) => sum + file.size, 0) +
        (props?.input?.machinebanner?.reduce(
          (sum, file) => sum + file.size,
          0
        ) || 0);
      if (totalSize > 5000000) {
        toast.error(
          "File size must not exceed 5 MB, and a maximum of 7 images can be uploaded."
        );
        props?.setbannerimagestate(
          props?.input?.machinebanner?.[props?.input?.machinebanner?.length - 1]
        );
        return;
      }
      props?.setinput({
        ...props?.input,
        machinebanner: combinedFiles,
      });
      setMachineBannersList(temp);
      setMachineBannersURLList(URL2);
    } catch (error) {
      toast.error("An error occurred while processing the banner.");
    }
  }

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="ai-model-open"
      backdrop="static"
    >
      {(loadingPrompt || loadingImage) && <MainpageLoader />}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Generate AI Image
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group
            className="mb-3 "
            controlId="exampleForm.ControlTextarea1"
          >
            <div className="d-flex  mb-2 main-magic-btn  justify-content-between align-items-center">
              <Form.Label>Prompt</Form.Label>
              <button
                className="blue-btn w-auto"
                onClick={handleOptimizePrompt}
                disabled={loadingPrompt || !prompt}
              >
                {loadingPrompt ? (
                  <SubmitLoading />
                ) : (
                  // <Spinner animation="border" size="sm" />
                  <div className="d-flex gap-1 align-items-center">
                    <span className="width16">
                      <img src={MagicWand} alt="MagicWand" />
                    </span>{" "}
                    <span>Magic</span>
                  </div>
                )}
              </button>
            </div>
            <Form.Control
              as="textarea"
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder="Enter Your Prompt"
              disabled={loadingPrompt || loadingImage}
              rows={3}
            />
          </Form.Group>
          {/* {error && toast.error(error)} */}
          {optimizedPrompts.map((optPrompt, index) => (
            <div
              onClick={() => handlePromptClick(optPrompt)}
              className="d-flex gap-3 align-items-start magic-inner-main "
            >
              <div className="magic-ai-inner">
                <img src={robot} alt="robot" />
              </div>
              <div
                key={index}
                className="mb-2"
                // onClick={() => handlePromptClick(optPrompt)}
                style={{ cursor: "pointer" }}
              >
                {optPrompt}
              </div>
            </div>
          ))}

          {/* Display Generated Images */}
          {/* <Form.Group>
            <Row>
              {test1.map((url, index) => (
                <Col
                  key={index}
                  xs={6}
                  md={4}
                  lg={3}
                  className={`mb-3 ${
                    MachineBannersList?.includes(url) ? "active" : ""
                  }`}
                >
                  <img
                    src={url}
                    alt={`Generated ${index}`}
                    className="img-fluid rounded"
                    onClick={(e) => fnMachineBanner(url)}
                  />
                </Col>
              ))}
            </Row>
            {!test1.length && !loadingImage && (
              <p className="text-muted text-center">
                No images generated yet. Enter a prompt to get started!
              </p>
            )}
          </Form.Group> */}
          <Form.Group>
            {loadingImage ? (
              <Loader type={LoaderType.AIGenerateModal} count={8} />
            ) : (
              <div className="ai-grid-inner">
                {imageUrls?.length > 0 &&
                  imageUrls?.map((url, index) => (
                    <div
                      key={index}
                      className="p-1"
                      // className="mb-3"
                      // className={`mb-3 ${
                      //   MachineBannersURLList?.includes("ai-" + index)
                      //     ? "active"
                      //     : ""
                      // }`}
                    >
                      <div
                        className={`mb-2 ai-image-generator p-0 ${
                          MachineBannersURLList?.includes("ai-" + index)
                            ? "active"
                            : ""
                        }`}
                      >
                        {/* edit button prakash after figma with proper design */}
                        {MachineBannersURLList?.includes("ai-" + index) && (
                          <span
                            onClick={(e) => {
                              setSelectedModalShow(true);
                              setImageName("ai-" + index);
                              setSelectedImage(url);
                              setImageIndex(index);
                            }}
                            className="cursor-pointer ai-imageedit-change"
                          >
                            <img src={editpencilIcon} alt="editpencilIcon" />
                          </span>
                        )}
                        <img
                          src={url}
                          alt={`Generated ${index}`}
                          className="img-fluid "
                          onClick={(e) => fnMachineBanner(url, "ai-" + index)}
                        />
                      </div>
                    </div>
                  ))}
                {/* : "no data"} */}
              </div>
            )}
            {/* {!imageUrls.length && !loadingImage && (
              <p className="text-muted text-center">
                No images generated yet. Enter a prompt to get started!
              </p>
            )} */}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button className="grey-btn w-auto" onClick={props.onHide}>
          Cancel
        </button>

        {props?.input?.machinebanner?.length > 0 ? (
          <button
            onClick={(e) => {
              props?.onHide();
            }}
            className="blue-btn w-auto"
          >
            Submit
          </button>
        ) : (
          <button
            onClick={generateImage}
            disabled={loadingImage || !prompt}
            className="blue-btn w-auto"
          >
            {loadingImage ? (
              <SubmitLoading />
            ) : imageUrls?.length > 0 ? (
              "Re-Generate Image"
            ) : (
              "Generate Image"
            )}
          </button>
        )}
      </Modal.Footer>
      {SelectedModalShow && (
        <EditAIImageModal
          show={SelectedModalShow}
          data={SelectedImage}
          images={imageUrls}
          setimages={setImageUrls}
          imageindex={ImageIndex}
          onHide={() => setSelectedModalShow(false)}
        />
      )}
    </Modal>
  );
};

export default AIImageGenerateModal;
